import { useState } from 'react';

export function useUnsplashState() {
  const [showUnsplash, setShowUnsplash] = useState(false);
  const [unsplashQuery, setUnsplashQuery] = useState("");
  const [unsplashResults, setUnsplashResults] = useState([]);
  const [unsplashLoading, setUnsplashLoading] = useState(false);

  return {
    showUnsplash, setShowUnsplash,
    unsplashQuery, setUnsplashQuery,
    unsplashResults, setUnsplashResults,
    unsplashLoading, setUnsplashLoading,
  };
}
